import { request } from '@tencent/ppd-base-libs';

/**
 * 获取banner的配置
 * @param bannerConfigUrl banner配置Url
 */
export async function getBannerConfig(bannerConfigUrl: string) {
  const data = await request.loadVtools(bannerConfigUrl);
  const { hkDiseaseBanner } = data;
  return hkDiseaseBanner as {
    seq: number;
    bannerImgUrl: {
      zh_hk: string;
      zh_cn: string;
      en: string;
    };
    bannerJumpUrl: {
      zh_hk: string;
      zh_cn: string;
      en: string;
    };
    bannerTime: {
      startTime: string;
      endTime: string;
    };
    bannerTag: string;
    bannerName: string;
  }[];
}
